export const getAuthToken = () => localStorage.getItem('apiToken');

export const setAuthToken = (authToken: string) => {
  localStorage.setItem('apiToken', authToken);
};

export const cleanAuthToken = () => {
  localStorage.removeItem('apiToken');
};
